import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Close, ErrorOutlineSharp, Folder } from '@mui/icons-material'
import Mapa from '../../componentes/mapa/Mapa';
const DatosGenerales = ({ datos, setDatos, errores, isOrganismo = false }) => {
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    const [mapa, setMapa] = useState(datos.geolocalizacion ?? '');
    useEffect(() => {
        const init = async () => {
            try {
                await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_${isOrganismo ? 'organismos' : 'es'}`)
                    .then(res => res.json())
                    .then((respuesta) => {
                        setCatalogoFiguras(respuesta.data);
                    });
            } catch (error) {

            }
        }
        init();
        
    }, []);

    const [logotipo, setLogotipo] = useState(datos.logotipo ? datos.logotipo.dataurl : '');
    const [galeria, setGaleria] = useState(Array.isArray(datos.galeria) && datos.galeria.length > 0 ? datos.galeria : []);
    useEffect(() => {
        setDatos({ target: { name: 'geolocalizacion', value: mapa } });
    }, [mapa]);

    const handleInput = (e, gal = false) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();

            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                if (gal) {
                    setGaleria([...galeria, imagen]);
                } else {
                    setDatos(e, imagen);
                    setLogotipo(readerEvent.target.result);
                }
            };

            reader.readAsDataURL(imagen);
        }
    }
    useEffect(() => {
        setDatos({ target: { name: "galeria", value: galeria } });
    }, [galeria]);

    const removeImg = (imgurl) => {
        setGaleria(galeria.filter(img => img.dataurl !== imgurl));
    }

    const handleFigura = (e, v) => {
        // si el valor es "otro", habilitar un campo libre.
        setDatos(e);
    }
    return (
        <Grid container spacing={1} sx={{ mb: { xs: 10, lg: 0 } }}>
            <Grid item lg={4} xs={12}>
                <Box sx={{ mb: 2 }}>
                    <TextField error={errores.includes('nombre_empresa')} fullWidth name="nombre_empresa" value={datos.nombre_empresa} onChange={setDatos} required label='Nombre' />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <TextField fullWidth error={errores.includes('nombre_comercial')} name="nombre_comercial" value={datos.nombre_comercial} onChange={setDatos} required label='Nombre Comercial' />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <TextField error={errores.includes('acronimo_empresa')} fullWidth name="acronimo_empresa" value={datos.acronimo_empresa} onChange={setDatos} required label='Acrónimo de la empresa' />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <FormControl fullWidth error={errores.includes('figura_juridica_es')}>
                        <InputLabel id="figura_juridica" required>Figura Jurídica</InputLabel>
                        <Select
                            labelId="figura_juridica"
                            name={isOrganismo ? "figura_juridica" : "figura_juridica_es"}
                            value={isOrganismo ? datos.figura_juridica : datos.figura_juridica_es}
                            label="Figura Juridica"
                            onChange={handleFigura}
                        >
                            {/* Obtener catalogo de figuras juridicas empresas sociales (tabla figuras_juridicas_es) */}
                            {catalogoFiguras.map((figura) => {
                                return (
                                    <MenuItem key={figura.id} value={figura.id}>{figura.nombre}</MenuItem>
                                )
                            })}
                            <MenuItem key="otro" value="otro">Otro</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                {(isOrganismo ? datos.figura_juridica === 'otro' : datos.figura_juridica_es === 'otro') &&
                    <Box sx={{ mb: 2 }}>
                        <TextField fullWidth error={errores.includes('figura_juridica_es_otro')} name="figura_juridica_es_otro" value={datos.figura_juridica_es_otro} onChange={setDatos} required label='Figura Jurídica' />
                    </Box>
                }

                <Box sx={{ mb: 2 }}>
                    <TextField fullWidth error={errores.includes('descripcion')} name="descripcion" value={datos.descripcion} onChange={setDatos} required label='Descripción de la empresa' />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <TextField fullWidth error={errores.includes('nombre_contacto')} name="nombre_contacto" value={datos.nombre_contacto} onChange={setDatos} required label='Nombre del contacto' />
                </Box>
            </Grid>
            {/* Lado derecho */}
            <Grid item lg={8} xs={12}>
                {/* Logo */}
                <Grid container spacing={1}>
                    <Grid item lg={6} xs={12}>
                        <Box>
                            <Box sx={{ mb: 2, }}>
                                <Typography textAlign='center' variant="h6">Logotipo*</Typography>
                            </Box>
                            <Box sx={{ mb: 2, display: 'flex' }}>
                                <Box sx={{ mx: 'auto', width: '200px', minHeight: '200px', border: 1, borderColor: errores.includes('logotipo') ? '#df090f' : '#e0dcda' }}>
                                    {logotipo && <img width="200px" src={logotipo} />}
                                </Box>
                            </Box>
                            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                                <Button component="label" variant="contained" startIcon={<Folder />}>
                                    Seleccionar <input name="logotipo" alt="Logotipo" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                </Button>
                            </Box>
                        </Box>
                    </Grid>

                    {/* galeria max 2 fotos */}
                    <Grid item lg={6} xs={12}>
                        <Box>
                            <Box sx={{ mx: 2, pt: 2 }}>
                                <Typography variant="h6">Fotogalería de las instalaciones*</Typography>
                                <Typography variant="subtitle1">(Máximo 2 fotografías)</Typography>
                            </Box>
                            <Box sx={{ mx: 2, mt: 2, display: 'flex' }}>
                                {galeria.map((image) => (
                                    <Box key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                        <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(image.dataurl)}>
                                            <Close />
                                        </IconButton>
                                        <img src={image.dataurl} alt={image.name} width="150px" />
                                    </Box>
                                ))}
                            </Box>
                            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                                <Button disabled={galeria.length > 1} component="label" variant="contained" startIcon={<Folder />}>
                                    Agregar <input name="galeria" onInputCapture={(e) => handleInput(e, true)} type="file" accept='image/*' hidden />
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider />
                <Box sx={{ my: 2 }}>
                    <Typography variant="h6">Domicilio</Typography>
                </Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={6}>
                        <Box sx={{ mb: 2 }}>
                            <TextField error={errores.includes('calle')} fullWidth name="calle" value={datos.calle} onChange={setDatos} required label='Calle' />
                        </Box>
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <Box sx={{ mb: 2 }}>
                            <TextField type="number" error={errores.includes('numero_ext')} fullWidth name="numero_ext" value={datos.numero_ext} onChange={setDatos} required label='Número exterior' />
                        </Box>
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="numero_int" value={datos.numero_int} onChange={setDatos} label='Número interior' />
                        </Box>
                    </Grid>
                    <Grid item xs={6} lg={2}>
                        <Box sx={{ mb: 2 }}>
                            <TextField type="number" inputProps={{ maxLength: 6 }} error={errores.includes('codigo_postal')} fullWidth name="codigo_postal" value={datos.codigo_postal} onChange={setDatos} required label='Código Postal' />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <Box sx={{ mb: 2 }}>
                            <TextField error={errores.includes('localidad')} fullWidth name="localidad" value={datos.localidad} onChange={setDatos} required label='Localidad' />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <Box sx={{ mb: 2 }}>
                            <TextField error={errores.includes('municipio')} fullWidth name="municipio" value={datos.municipio} onChange={setDatos} required label='Municipio' />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <Box sx={{ mb: 2 }}>
                            <TextField error={errores.includes('estado')} fullWidth name="estado" value={datos.estado} onChange={setDatos} required label='Estado' />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Box sx={{ mb: 10 }}>
                            <Mapa start={mapa != '' ? { lat: Number(mapa.split(',')[0]), lng: Number(mapa.split(',')[1]) } : {
                                lat: 20.6854551,
                                lng: -103.3542671
                            }} editable={true} buscador={true} handleSelect={(newVal) => {
                                setMapa(() => {
                                    return `${newVal.lat},${newVal.lng}`;
                                })
                            }} />
                            {/* <TextField fullWidth name="geolocalizacion" value={datos.geolocalizacion} onChange={setDatos} required label='Mapa' /> */}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            {/* Contacto y redes sociales */}
            <Grid item xs={12}>
                <Divider />
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                        <Box sx={{ py: 2, }}>
                            <Typography variant="h6">Contacto</Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField inputProps={{ maxLength: 10 }} error={errores.includes('telefono')} fullWidth name="telefono" value={datos.telefono} type="tel" InputProps={{ inputProps: { min: 10 } }} onChange={setDatos} required label='Teléfono' />
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField inputProps={{ maxLength: 10 }} fullWidth name="whatsapp" value={datos.whatsapp} type="tel" InputProps={{ inputProps: { min: 10 } }} onChange={setDatos} label='WhatsApp' />
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField error={errores.includes('email')} fullWidth name="email" value={datos.email} onChange={setDatos} required label='Correo electrónico' />
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="pagina_web" value={datos.pagina_web} onChange={setDatos} label='Página Web' />
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Box sx={{ py: 2, }}>
                            <Typography variant="h6">Redes sociales</Typography>
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="facebook" value={datos.facebook} onChange={setDatos} label='Facebook' />
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="instagram" value={datos.instagram} onChange={setDatos} label='Instagram' />
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="tiktok" value={datos.tiktok} onChange={setDatos} label='TikTok' />
                        </Box>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="x_twitter" value={datos.x_twitter} onChange={setDatos} label='X (Antes Twitter)' />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ mb: 2 }}>
                            <TextField fullWidth name="url_tienda" value={datos.url_tienda} onChange={setDatos} label='Tienda en línea (URL)' />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}

export default DatosGenerales